const config = {
  API_URL: process.env.API_URL,
  OAUTH_URL: process.env.OAUTH_URL,
  INVOICE_URL: 'https://invoices.cloud.pm2.io',
  OAUTH_CLIENT_ID: process.env.CLIENT_ID,
  DEFAULT_NOTIFICATION_TIMEOUT: 3000,
  REALTIME_UPDATE_INTERVAL: 0,
  REALTIME_HISTORY_DURATION: 30000,
  DEFAULT_DEBOUNCED_RESIZE: 1500,
  DEDICATED: process.env.DEDICATED === 'true',
}

export default config
